import { render, staticRenderFns } from "./iconMore.vue?vue&type=template&id=c74304bc&scoped=true"
import script from "./iconMore.vue?vue&type=script&lang=js"
export * from "./iconMore.vue?vue&type=script&lang=js"
import style0 from "./iconMore.vue?vue&type=style&index=0&id=c74304bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c74304bc",
  null
  
)

export default component.exports